import * as React from 'react';
import { TileViewProps, TileView } from 'ui/tile-view';
import { AddDocumentItemOptions } from 'app/infrastructure/ui/form/types';
import { ComplexValue } from 'app/types-shared';
import { DocumentItemFromMultiSelectProps, DocumentItemFromMultiSelect } from 'app/components/document-item-from-multiselect';

export interface CodeSelectorTileViewProps extends DocumentItemFromMultiSelectProps, TileViewProps {
  textCodeSelectorTitle: string;
  textDone: string;
  categoryId?: number;
  minLevel?: number;
  existingKeys: ComplexValue<number>[];
  onAddDocumentItem: (selectAddedItem?: boolean, options?: AddDocumentItemOptions) => void;
  leafNodeOnly?: boolean;
  extraFooterButton?: (onCloseCallback: (onClose: void) => void) => JSX.Element;
  displaySelectAll?: boolean;
}

export const CodeSelectorTileView: React.FC<React.PropsWithChildren<CodeSelectorTileViewProps>> = (props) => {
  const { label, categoryId, minLevel, readOnly, enabledChildEntityOperations, leafNodeOnly, extraFooterButton, displaySelectAll } = props;

  const required = label && label.required;
  
  const addButton = !readOnly && enabledChildEntityOperations?.add &&
    <DocumentItemFromMultiSelect 
      {...props}
      categoryId={categoryId}
      minLevel={minLevel}
      required={required}
      children={undefined}
      leafNodeOnly={leafNodeOnly}
      extraFooterButton={extraFooterButton}
      displaySelectAll={displaySelectAll}
    />; 

  return (
    <TileView {...props} addButton={addButton} rowClassName={props.rowClassName}/>
  );
};
